import { FunctionComponent } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import HtmlStyledContent from 'components/layout/HtmlStyledContent';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutSectionProductFaq: FunctionComponent<Props> = ({ faqs, headline, subheadline }) => {
    const sortedFaqs = faqs.sort((a, b) => a.order - b.order);

    const handlerCollapseByClass = (e) => {
        if (e.currentTarget.classList.contains('active')) return e.currentTarget.classList.remove('active');
        return e.currentTarget.classList.add('active');
    };

    return (
        <StyledComponent className="public-section-faq-variant-default">
            <LayoutContainer>
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                {subheadline && (
                    <div
                        className="subheadline"
                        dangerouslySetInnerHTML={{ __html: subheadline }}
                    />
                )}
                {sortedFaqs.length > 0 && sortedFaqs.map(({ title, content }) => (
                    <div
                        key={title}
                        className="rows-container"
                    >
                        <div
                            className="row"
                            onClick={(e: React.MouseEvent<HTMLDivElement>) => handlerCollapseByClass(e)}
                        >
                            <div className="clickable-title">
                                <div
                                    className="row-title"
                                    dangerouslySetInnerHTML={{ __html: title }}
                                />
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    size="xs"
                                    className='icon'
                                />
                            </div>
                            <HtmlStyledContent
                                className="row-description"
                                html={content}
                            />
                        </div>
                    </div>
                ))}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutSectionProductFaq;
